<div class="account-page">

  <!-- Header avec retour intégré -->
  <div class="account-header">
    <button class="account-header__back" (click)="goBack()" aria-label="Retour">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="account-header__text">
      <p class="account-header__name">{{ account.username || 'Mon profil' }}</p>
      <p class="account-header__email">{{ account.email }}</p>
    </div>
    <div class="account-header__spacer"></div>
  </div>

  <!-- Hub : cartes de navigation -->
  <section class="account-hub">
    <!-- Identifiants & sécurité -->
    <button class="hub-card" (click)="openIdentitySheet()">
      <div class="hub-card__icon hub-card__icon--blue"><mat-icon>person</mat-icon></div>
      <div class="hub-card__body">
        <span class="hub-card__title">Identifiants & sécurité</span>
        <span class="hub-card__subtitle" *ngIf="isPhoneSet() && isPasswordChanged()">Email, pseudo, téléphone, mot de passe</span>
        <span class="hub-card__subtitle hub-card__subtitle--warn" *ngIf="!isPhoneSet() || !isPasswordChanged()">
          <mat-icon class="hub-card__warn-icon">warning</mat-icon>
          {{ !isPhoneSet() && !isPasswordChanged() ? 'Téléphone et mot de passe à compléter' :
             !isPhoneSet() ? 'Téléphone à renseigner' : 'Mot de passe à modifier' }}
        </span>
      </div>
      <mat-icon class="hub-card__chevron">chevron_right</mat-icon>
    </button>

    <!-- Commandes -->
    <button class="hub-card" *ngIf="account.commandes && account.commandes.length > 0" (click)="openOrdersSheet()">
      <div class="hub-card__icon hub-card__icon--accent"><mat-icon>shopping_bag</mat-icon></div>
      <div class="hub-card__body">
        <span class="hub-card__title">Mes commandes</span>
        <span class="hub-card__subtitle">{{ account.commandes.length }} commande{{ account.commandes.length > 1 ? 's' : '' }}</span>
      </div>
      <mat-icon class="hub-card__chevron">chevron_right</mat-icon>
    </button>
  </section>

  <!-- Section : Profils socio (inline car mode édition) -->
  <section class="account-section">
    <h2 class="account-section__title"><mat-icon>people</mat-icon> Mes profils</h2>

    <div class="profile-card" *ngFor="let socio of account.socios || []"
         [id]="'socio-' + socio.id" isEditing="0">

      <!-- En-tête -->
      <div class="profile-card__header">
        <div class="profile-card__badge"><mat-icon>person_outline</mat-icon></div>
        <div class="profile-card__info">
          <span class="profile-card__title">
            {{ (socio.roles.isSocio) ? 'Socio#' + socio.techId : '' }}
            {{ (socio.roles.isSocio && socio.roles.isAdherent) ? ' — ' : '' }}
            {{ (socio.roles.isAdherent) ? 'Adhérent' + ((socio.roles.isSocio) ? '' : '#' + socio.id) : '' }}
            <mat-icon *ngIf="!isCountrySet(socio)" color="warn" class="inline-warn">error</mat-icon>
          </span>
          <span class="profile-card__subtitle">{{ socio.prenom }} {{ socio.nom }}</span>
        </div>
        <div class="profile-card__actions readMode">
          <button mat-icon-button (click)="editMode(socio.id, true)" matTooltip="Modifier"><mat-icon>edit</mat-icon></button>
          <button *ngIf="account.socios && account.socios.length > 1" mat-icon-button
                  (click)="moveSocio(socio.id)" matTooltip="Déplacer"><mat-icon>open_in_new</mat-icon></button>
        </div>
      </div>

      <!-- Lecture -->
      <div class="profile-card__body readMode">
        <div class="profile-row">
          <mat-icon>cake</mat-icon>
          <span>{{ socio.date_naissance | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="profile-row" *ngIf="socio.mail">
          <mat-icon>email</mat-icon>
          <span>{{ socio.mail }}</span>
        </div>
        <div class="profile-row">
          <mat-icon>home</mat-icon>
          <span>{{ socio.adresse }}, {{ socio.code_postal }} {{ socio.ville }}, {{ socio.pays }}
            <mat-icon *ngIf="!isCountrySet(socio)" color="warn" class="inline-warn-sm">error</mat-icon>
          </span>
        </div>
        <div class="profile-row" *ngIf="socio.maillot">
          <mat-icon>checkroom</mat-icon>
          <span>Maillot reçu</span>
        </div>
      </div>

      <!-- Édition -->
      <div class="profile-card__edit editMode">
        <div class="profile-edit-grid">
          <mat-form-field appearance="outline">
            <mat-label>Nom</mat-label>
            <input matInput type="text" [(ngModel)]="socio.nom">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Prénom</mat-label>
            <input matInput type="text" [(ngModel)]="socio.prenom">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Date de naissance</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="socio.date_naissance">
            <mat-hint>JJ/MM/AAAA</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Rue</mat-label>
            <input matInput type="text" [(ngModel)]="socio.adresse">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Code postal</mat-label>
            <input matInput type="text" [(ngModel)]="socio.code_postal">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Ville</mat-label>
            <input matInput type="text" [(ngModel)]="socio.ville">
          </mat-form-field>
          <mat-form-field appearance="outline" class="profile-edit-full">
            <mat-label>Pays</mat-label>
            <mat-select [value]="capitalizeFirstLetter(socio.pays)" [(ngModel)]="socio.pays">
              <mat-option *ngFor="let country of countries" [value]="country.name">{{ country.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="profile-edit-actions">
          <button mat-stroked-button color="warn" (click)="editMode(socio.id, false)"><mat-icon>close</mat-icon> Annuler</button>
          <button mat-flat-button color="primary" (click)="validate(socio.id)"><mat-icon>check</mat-icon> Valider</button>
        </div>
      </div>
    </div>
  </section>

  <!-- Section : Informations légales -->
  <section class="account-section account-legal">
    <a href="assets/legal/privacy-policy.html" target="_blank" class="legal-link">
      <mat-icon>privacy_tip</mat-icon>
      <span>Politique de confidentialité</span>
      <mat-icon class="legal-link__chevron">open_in_new</mat-icon>
    </a>
    <a href="assets/legal/terms-of-service.html" target="_blank" class="legal-link">
      <mat-icon>description</mat-icon>
      <span>Conditions générales d'utilisation</span>
      <mat-icon class="legal-link__chevron">open_in_new</mat-icon>
    </a>
    <a href="assets/legal/data-deletion.html" target="_blank" class="legal-link">
      <mat-icon>delete_outline</mat-icon>
      <span>Suppression des données</span>
      <mat-icon class="legal-link__chevron">open_in_new</mat-icon>
    </a>
  </section>

  <!-- Section : Zone dangereuse -->
  <section class="account-section account-danger">
    <button class="danger-link" (click)="openDeleteAccountSheet()">
      <mat-icon>delete_forever</mat-icon>
      <span>Supprimer mon compte</span>
      <mat-icon class="danger-link__chevron">chevron_right</mat-icon>
    </button>
  </section>

</div>
